import styled from 'styled-components'
import { grayPrimary } from '../../color'
import { Menu } from 'antd'

export const PageWrappper = styled.main`
  padding: 15px;
  max-width: 1024px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`

export const ProfileGroupWrapper = styled.div`
  margin-bottom: 0;

  .ant-col.ant-form-item-label {
  }
`

export const ProfileGroupWrapperCart = styled.div`
  margin-bottom: 0;

  .ant-col.ant-form-item-label {
    font-weight: bold;
    padding: 5px 5px 5px 7px;
    border-radius: 2px;
    background: rgba(249, 249, 249, 0.7);
  }

  .ant-form-item-control-input {
    padding-left: 7px;
    background-color: rgba(250, 250, 250, 0.2);
  }
`

export const MenuWrapper = styled(Menu)`
  .ant-menu-item {
    border: 1px solid #def2ff;
    border-radius: 8px;
    height: 45px;
    line-height: 43px;
    margin-top: 0 !important;
    transition: all ease 0.3s;
    &:hover,
    &.ant-menu-item-selected {
      transition: all ease 0.3s;
      background-color: #eff8fe;
      border-color: #00b2ff;
    }
  }
`

export const TabContentWrapper = styled.div`
  border-radius: 16px;
  background-color: #f6f6f6;
  padding: 20px;
  flex: 1;
`

export const TabContentWrapperTitle = styled.h2`
  color: #000;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
`

export const TabContentWrapperInnerContent = styled.h2`
  background-color: white;
  min-height: 300px;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 0;
`

export const OverviewWrapper = styled.div`
  display: flex;
  column-gap: 40px;
  padding-top: 10px;

  .avatar {
    padding: 5px;
    background-color: #ffe6bb;
    border-radius: 50%;
    position: relative;
    height: 100px;

    .edit-avatar-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: #e4e6eb;
      font-size: 22px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #504f4f;

      &:hover {
        font-size: 24px;
        transition: 0.4s;
      }
    }
  }

  .overview-info {
    flex-grow: 1;

    .item-info {
      flex-direction: column;
      display: inline;
      column-gap: 8px;
      margin-bottom: 10px;

      .desc {
        margin-left: 20px;
        font-size: 10px;
        color: ${grayPrimary};
      }
    }
  }

  .ant-typography {
    margin-bottom: 0;
  }

  .ant-typography.ant-typography-edit-content {
    transition: 0.3s;
    transform: translateX(10px);
  }

  .ant-radio-group {
    display: block;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`

export const InfoListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`

export const InfoList = styled.dl`
  background-color: #f6f6f6;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 0;
  dt,
  dd {
    font-size: 14px;
  }
  dt {
    font-weight: 400;
  }
  dd {
    font-weight: 500;
    margin-bottom: 0;
  }
`

export const UserName = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  .username {
    margin-left: 4px;
    font-weight: 500;
    font-size: 14px;
    color: ${grayPrimary};
    text-transform: lowercase;
  }
`
